import React from "react";
import { Box, Typography, Grid } from "@mui/material";

import VB_Logo from "./../../assets/images/VB-logo.png";
import { useTranslation } from "react-i18next";

const GeneralVB = () => {
  const { t } = useTranslation();

  return (
    <Box pt={2} px={8} pb={10}>
      <Box sx={{ textAlign: "center" }}>
        <Grid container spacing={2} mt={2}>
          <Grid item md={4} xs={0}>
            <Box></Box>
          </Grid>
          <Grid item md={4} xs={12}>
            <Box>
              <Box as="img" src={VB_Logo} width="55%" mt={5} />
            </Box>
          </Grid>
          <Grid item md={4} xs={0}>
            <Box></Box>
          </Grid>
        </Grid>
        <Typography mt={5} fontSize={"1.25rem"} sx={{}} className="general-text"
>
          {t("genaral-vb-h1")}
        </Typography>
        {/* <Typography mt={3} fontSize={"1.25rem"}>
          {t("genaral-vb-h2-sub-1")}
          <br></br>
          {t("genaral-vb-h2-sub-2")}
        </Typography> */}
      </Box>
    </Box>
  );
};

export default GeneralVB;
